import { Images } from "../assets";

const ServiceList = ({ title, services, table = [] }) => {
  return (
    <div className="flex flex-col items-start text-start w-full md:w-1/2 lg:w-2/3 bg-orange text-black rounded-lg p-6 justify-center">
      <h3 className="font-title tracking-widest uppercase text-2xl mb-5">
        {title}
      </h3>
      <ul className="text-base md:text-xl space-y-3 md:space-y-5">
        {services.map((service, index) => (
          <li key={index} className="flex gap-2 md:gap-3 items-center">
            <img
              src={Images.WHITE_TICK}
              alt="Tick Icon"
              className="w-4 h-4 md:w-6 md:h-6"
            />
            <span>{service.text}</span>
          </li>
        ))}
      </ul>
      {table.length > 0 && (
        <div className="grid grid-cols-3 gap-3 mt-10 w-full lg:grid-cols-6">
          {table.map((item, index) => (
            <div
              key={index}
              className="flex flex-col items-center italic font-light p-1 bg-white text-orange rounded-md"
            >
              <span className="text-sm md:text-base">{item[0]}</span>
              <span className="text-sm md:text-base">{item[1]}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ServiceList;
